import 'leaflet'
import Vue from 'vue'

const VueBaseContextMenu = L.Handler.extend({
  _touchstart: L.Browser.msPointer
    ? 'MSPointerDown'
    : L.Browser.pointer
    ? 'pointerdown'
    : 'touchstart',

  _contextListener: function (data) {
    if (data.action === 'closeMenu') {
      this.hide()
    }
  },

  initialize: function (map, config = {}) {
    L.Handler.prototype.initialize.call(this, map)

    this.$emitter = Vue.prototype.$emitter
    this.$emitter.listen('leaflet.context', (data) =>
      this._contextListener(data)
    )

    this._visible = false
    var defaultConfig = {
      statics: {
        BASE_CLS: 'leaflet-contextmenu',
      },
    }
    config = Object.assign(config, defaultConfig)
    this.statics = {}
    this.statics.BASE_CLS = config.statics.BASE_CLS

    var container = (this._container = L.DomUtil.create(
      'div',
      this.statics.BASE_CLS,
      map._container
    ))
    container.style.zIndex = 10000
    container.style.display = 'none'
    container.style.position = 'absolute'

    if (map.options.contextmenuWidth) {
      container.style.width = map.options.contextmenuWidth + 'px'
    }

    this._createMenu()

    L.DomEvent.on(container, 'mousedown', L.DomEvent.stop).on(
      container,
      'contextmenu',
      L.DomEvent.stop
    )
    map.on('contextmenu.open', this._showFromLayer, this)
  },

  addHooks: function () {
    var container = this._map.getContainer()

    L.DomEvent.on(container, 'mouseleave', this._hide, this).on(
      document,
      'keydown',
      this._onKeyDown,
      this
    )

    if (L.Browser.touch) {
      L.DomEvent.on(document, this._touchstart, this._hide, this)
    }

    this._map.on(
      {
        contextmenu: this._show,
        mousedown: this._hide,
        movestart: this._hide,
        zoomstart: this._hide,
      },
      this
    )
  },

  removeHooks: function () {
    var container = this._map.getContainer()

    L.DomEvent.off(container, 'mouseleave', this._hide, this).off(
      document,
      'keydown',
      this._onKeyDown,
      this
    )

    if (L.Browser.touch) {
      L.DomEvent.off(document, this._touchstart, this._hide, this)
    }

    this._map.off(
      {
        contextmenu: this._show,
        mousedown: this._hide,
        movestart: this._hide,
        zoomstart: this._hide,
      },
      this
    )
  },

  showAt: function (point, data) {
    if (point instanceof L.LatLng) {
      point = this._map.latLngToContainerPoint(point)
    }
    this._showAtPoint(point, data)
  },

  hide: function () {
    this._hide()
  },

  isVisible: function () {
    return this._visible
  },

  getVueComponent: function () {
    console.error('describe new Vue(componentName)')
    return null
  },

  _vueComponent: null,
  _createVueComponent: function (el) {
    let childDiv = document.createElement('div')
    el.appendChild(childDiv)
    this._vueComponent = this.getVueComponent()
    this._vueComponent.$mount(childDiv)
  },

  _createMenu: function () {
    var itemCls = this.statics.BASE_CLS + '-item',
      cls = itemCls,
      el = this._insertElementAt('div', cls, this._container)

    this._createVueComponent(el)

    L.DomEvent.on(el, 'mouseover', this._onItemMouseOver, this)
      .on(el, 'mouseout', this._onItemMouseOut, this)
      .on(el, 'mousedown', L.DomEvent.stopPropagation)

    if (L.Browser.touch) {
      L.DomEvent.on(el, this._touchstart, L.DomEvent.stopPropagation)
    }

    L.DomEvent.on(
      el,
      'click',
      function ($event) {
        this.hide()
        // TODO: ???
        $event.preventDefault()
      },
      this
    )
  },

  _insertElementAt: function (tagName, className, container, index) {
    var refEl,
      el = document.createElement(tagName)

    el.className = className

    if (index !== undefined) {
      refEl = container.children[index]
    }

    if (refEl) {
      container.insertBefore(el, refEl)
    } else {
      container.appendChild(el)
    }

    return el
  },

  acceptShow: function () {
    console.error('describe accept show')
  },

  acceptShowFromLayer: function () {
    console.error('describe accept show fromLayer')
  },

  _layer: null,
  _showFromLayer: function (options) {
    this._layer = null
    var e = options.event
    if (this.acceptShowFromLayer(options)) {
      // disable relation contextn menu on cluster
      // check model
      if (
        options.layer &&
        options.layer.options &&
        options.layer.options.model
      ) {
        this._layer = options.layer
        this._vueComponent.injectConf({
          map: this._map,
          layer: this._layer,
          e: e,
        })
        this._showAtPoint(e.containerPoint, e)
      }
      e.originalEvent.preventDefault()
    }
  },

  _show: function (e) {
    this._layer = null
    if (this.acceptShow(e)) {
      this._vueComponent.injectConf({
        map: this._map,
        layer: this._layer,
        e: e,
      })
      this._showAtPoint(e.containerPoint, e)
      e.originalEvent.preventDefault()
    }
  },

  _showAtPoint: function (pt, data) {
    if (this._map.options.contextmenuOpened === false) {
      var map = this._map,
        layerPoint = map.containerPointToLayerPoint(pt),
        latlng = map.layerPointToLatLng(layerPoint),
        event = L.extend(data || {}, { contextmenu: this })

      // set in _geoJsonLayer actual mouse right clik postiion
      // for use in opened popup (BasePopup.js)
      if (this._layer && this._layer.options) {
        this._layer.options.lastEventPos = latlng
        this._layer.options.lastEventPoint = layerPoint
        this._layer.options.lastEvent = event
      }

      this._showLocation = {
        latlng: latlng,
        layerPoint: layerPoint,
        containerPoint: pt,
      }

      if (data && data.relatedTarget) {
        this._showLocation.relatedTarget = data.relatedTarget
      }

      this._setPosition(pt, data)

      if (!this._visible) {
        this._container.style.display = 'block'
        this._visible = true
      }

      this._map.options.contextmenuOpened = true
      this._map.fire('contextmenu.show', event)
    }
  },

  _hide: function () {
    if (this._visible) {
      this._map.options.contextmenuOpened = false
      this._layer = null
      this._visible = false
      this._container.style.display = 'none'
      this._map.fire('contextmenu.hide', { contextmenu: this })
    }
  },
  /**
   *
   * @param pt containerPoint
   * @param data Leaflet event
   * @private
   */
  _setPosition: function (pt) {
    var mapSize = this._map.getSize(),
      container = this._container,
      containerSize = this._getElementSize(container),
      anchor

    if (this._map.options.contextmenuAnchor) {
      anchor = L.point(this._map.options.contextmenuAnchor)
      pt = pt.add(anchor)
    }

    container._leaflet_pos = pt

    if (pt.x + containerSize.x > mapSize.x) {
      container.style.left = 'auto'
      container.style.right =
        Math.min(
          Math.max(mapSize.x - pt.x, 0),
          mapSize.x - containerSize.x - 1
        ) + 'px'
    } else {
      container.style.left = Math.max(pt.x, 0) + 'px'
      container.style.right = 'auto'
    }

    if (pt.y + containerSize.y > mapSize.y) {
      container.style.top = 'auto'
      container.style.bottom =
        Math.min(
          Math.max(mapSize.y - pt.y, 0),
          mapSize.y - containerSize.y - 1
        ) + 'px'
    } else {
      container.style.top = Math.max(pt.y, 0) + 'px'
      container.style.bottom = 'auto'
    }
  },

  _getElementSize: function (el) {
    var size = this._size,
      initialDisplay = el.style.display

    if (!size || this._sizeChanged) {
      size = {}

      el.style.left = '-999999px'
      el.style.right = 'auto'
      el.style.display = 'block'

      size.x = el.offsetWidth
      size.y = el.offsetHeight

      el.style.left = 'auto'
      el.style.display = initialDisplay

      this._sizeChanged = false
    }

    return size
  },

  _onKeyDown: function (e) {
    var key = e.keyCode

    // If ESC pressed and context menu is visible hide it
    if (key === 27) {
      this._hide()
    }
  },

  _onItemMouseOver: function (e) {
    L.DomUtil.addClass(e.target || e.srcElement, 'over')
  },

  _onItemMouseOut: function (e) {
    L.DomUtil.removeClass(e.target || e.srcElement, 'over')
  },
})

export default VueBaseContextMenu
